import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
};

const updateBidReducers = (state = initialState, action) => { 
  switch (action.type) {
    case types.UPDATE_BID_REQUESTED:
      return {
        ...state,
        loading: action.payload.loading,
        // success: false,
      };

    case types.UPDATE_BID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        error: false,
      };

    case types.UPDATE_BID_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    case types.CLEAR_UPDATE_BID_SUCCESS:
      return {
        loading: false,
        success: false,
        error: false,
      };

    case types.FETCH_DECLINED_REASONS_BIDS_INIT:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_DECLINED_REASONS_BIDS_SUCCESS:
      return {
        ...state,
        loading: false,
        declinedReasonsBid: action.payload,
      };

    case types.FETCH_DECLINED_REASONS_BIDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
export default updateBidReducers;
